import { yearSummary } from "../domain/year-summary";
import { weekSummary } from "../domain/week-summary";
import { useEffect, useState, type FormEvent, } from "react";
import { activeProject, } from "../domain/project";
import { deriveProjectCommand, } from "../domain/project-command";
import type {
  AppData,
} from "../domain/types";

import { StageBoard } from "../components/shared";
export function HomeView({ data, navigate, onToggleTask, onCreateProject }: { data: AppData; navigate: (to: string) => void; onToggleTask: (projectId: string, taskId: string) => void; onCreateProject: (mediaTitle: string, characterName: string) => void }) {
  const weekly=weekSummary(data);
  const year=new Date().getFullYear();const recap=yearSummary(data);const recapKey=`haebolcae.recap-${year}`;
  const [showRecap]=useState(()=>{try{return new Date().getMonth()===11&&!localStorage.getItem(recapKey);}catch{return false;}});
  useEffect(()=>{if(showRecap&&recap.projects.length)try{localStorage.setItem(recapKey,"1");}catch{/* This reminder never blocks local preparation. */}},[showRecap,recap.projects.length,recapKey]);
  const active = activeProject(data);
  const command = active ? deriveProjectCommand(data, active) : undefined;
  const [mediaTitle, setMediaTitle] = useState("");
  const [characterName, setCharacterName] = useState("");
  const [formError, setFormError] = useState("");
  const submitQuickStart = (event: FormEvent) => {
    event.preventDefault();
    if (!mediaTitle.trim() || !characterName.trim()) {
      setFormError("작품명과 캐릭터명을 모두 입력해 주세요.");
      return;
    }
    setFormError("");
    onCreateProject(mediaTitle, characterName);
  };
  return (
    <>
      {showRecap&&recap.projects.length>0&&<aside className="week-strip"><button type="button" className="button" onClick={()=>navigate("/portfolio")}>{year}년 결산 보기</button></aside>}
      {(weekly.rows.length>0||weekly.bags.length>0||weekly.backupDays!==undefined)&&<section className="week-strip"><h2>이번 주 {weekly.rows.length+weekly.bags.length}개</h2>{weekly.rows.map(row=><div key={row.id}><button type="button" className="button text" onClick={()=>row.taskId?onToggleTask(row.projectId,row.taskId):navigate(row.route)}>{row.date} · {row.label}{row.taskId?" · 완료하기":""}</button></div>)}{weekly.bags.map(row=><button type="button" className="button text" key={row.id} onClick={()=>navigate(row.route)}>{row.label}</button>)}{weekly.backupDays!==undefined&&<button type="button" className="button text" onClick={()=>navigate("/settings/data")}>백업한 지 {weekly.backupDays}일 · 옮길 준비하기</button>}</section>}
      <section className="project-board" aria-labelledby="quick-start-title" data-testid="home-project-board">
        <header className="project-board-head">
          <div>
            
            <h1 id="quick-start-title">이번에 입을 캐릭터, 촬영 당일까지 준비표 한 장으로</h1>
          </div>
          <p>작품과 캐릭터를 적으면 의상 파츠·할 일·촬영 순서가 만들어져요. 로그인 없이 이 기기에 저장돼요.</p>
        </header>

        <form className="project-intake" onSubmit={submitQuickStart}>
          <label><span>작품명</span><input aria-label="작품명" value={mediaTitle} onChange={(event) => setMediaTitle(event.target.value)} placeholder="예: 장송의 프리렌" autoComplete="off" /></label>
          <label><span>캐릭터명</span><input aria-label="캐릭터명" value={characterName} onChange={(event) => setCharacterName(event.target.value)} placeholder="예: 프리렌" autoComplete="off" /></label>
          <button className="board-submit" type="submit" aria-label="준비표 만들기"><strong>준비표 만들기</strong></button>
          {formError && <p className="form-error" role="alert">{formError}</p>}
        </form>

        <aside className={`project-board-output${active ? " active" : ""}`} aria-label={active ? `${active.characterName}의 다음 준비` : "준비표를 만들면 생기는 기록"}>
          {active && command ? <>
            <div className="output-title"><span>진행 중</span><strong>{active.characterName}</strong><small>{active.mediaTitle} · {active.dDay || "촬영일 미정"}</small></div>
            <div className="output-next"><span>지금 할 일</span><strong>{command.nextAction.label}</strong><small>실제 확인 {command.evidenceProgress.ready}/{command.evidenceProgress.required}</small></div>
            <button className="button primary" onClick={() => navigate(command.nextAction.route)}>이어서 준비</button>
            <button className="button text" onClick={() => navigate(`/project/${active.id}`)}>전체 준비표 →</button>
          </> : <>
            <div className="output-title"><span>생성되는 기본 기록</span><strong>입력 뒤 바로 확인</strong></div>
            <dl>
              <div><dt>의상</dt><dd>상의·하의·가발·신발·소품·메이크업</dd></div>
              <div><dt>일정</dt><dd>촬영일까지 필요한 기본 할 일</dd></div>
              <div><dt>권리</dt><dd>행사 규칙·촬영·사진 공개 확인</dd></div>
            </dl>
            <p>촬영일과 각 항목은 준비표에서 바로 바꿀 수 있습니다.</p>
          </>}
        </aside>

        <footer className="project-board-foot">
          <span>내 기기에 저장 · 언제든 백업</span>
          <button className="button text" onClick={() => navigate("/events")}>다가오는 행사에서 고르기 →</button><button className="button text" onClick={() => navigate("/discover")}>무엇을 입을지 모르겠어요 →</button>
        </footer>
      </section>

      {active && <StageBoard project={active} onToggle={(taskId) => onToggleTask(active.id, taskId)} />}
    </>
  );
}

